import {
  createStyles,
  Grid,
  Typography,
  withStyles,
  type WithStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import { FeedBackPage } from "features/shared/components";
import React from "react";
import { MAGNIFYING_GLASS_IMAGE_URL } from "../../../utils/lots.utils";

type EmptyLotsTableProps = {
  isFilterApplied: boolean;
} & WithStyles<typeof styles>;

function EmptyLotsTable({ classes, isFilterApplied }: EmptyLotsTableProps) {
  const { t } = useTranslations();

  const message = isFilterApplied
    ? t("common:no-values-for-filter")
    : t("livestock:no-registered-lot");

  return (
    <Grid
      className={classes.root}
      container={true}
      direction="column"
      justify="center"
    >
      <FeedBackPage>
        <Grid container direction="column" alignItems="center">
          <img
            alt={t("common:magnifying-glass")}
            src={MAGNIFYING_GLASS_IMAGE_URL}
          />
          <Typography className={classes.text}>{message}</Typography>
        </Grid>
      </FeedBackPage>
    </Grid>
  );
}

const styles = () =>
  createStyles({
    root: {
      minHeight: "40vh",
    },
    text: {
      color: "#666666",
      paddingTop: 10,
      textAlign: "center",
    },
  });

export default withStyles(styles)(EmptyLotsTable);
